export default "__VITE_ASSET__3b2a41c2__"